// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__13s75","tabs":"style_tabs__qxSwG","item":"style_item__1PIYh","active":"style_active__2f7ut","box":"style_box__1RD3A"};